import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/case-study/middle-east-event/MEES_Thumb.png"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="Middle East Event Show Success - Premagic Case Study"
      description="Discover how Middle East Event Show achieved 300% engagement boost with Premagic's AI platform. Real results & proven ROI metrics."
      metaImage={ThumbnailImage}
      keywords={[
        "Middle East Event Show, MEES case study, Dubai event success, UAE event technology, Middle East events, Gulf event management, Arab event industry, Dubai conference technology, UAE event platform, Middle East MICE, Gulf event solutions, Arab world events, Dubai exhibition technology, regional event success, Middle East event marketing",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Middle East Event Show", url: "/case-study/middle-east-event-show/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Middle East Event Show Success - Premagic Case Study",
            "description": "Discover how Middle East Event Show achieved 300% engagement boost with Premagic's AI platform. Real results & proven ROI metrics.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.MIDDLE_EAST_EVENT_SHOW} />
    </Layout>
  )
}

export default Index
